import { render, staticRenderFns } from "./TrainingInfo.vue?vue&type=template&id=b0c9a91c&scoped=true"
import script from "./TrainingInfo.vue?vue&type=script&lang=js"
export * from "./TrainingInfo.vue?vue&type=script&lang=js"
import style0 from "./TrainingInfo.vue?vue&type=style&index=0&id=b0c9a91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c9a91c",
  null
  
)

export default component.exports